import React from "react";

const UserStar = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M15.754 20.87v11.613H4c0-3.08 1.238-6.033 3.443-8.211a11.827 11.827 0 0 1 8.31-3.401Zm8.815 10.887L20.251 34l.825-4.75-3.493-3.364 4.828-.694 2.158-4.322 2.16 4.322 4.827.694-3.493 3.364.823 4.75-4.317-2.243ZM15.754 19.42c-4.87 0-8.816-3.898-8.816-8.71C6.938 5.897 10.883 2 15.754 2c4.87 0 8.815 3.897 8.815 8.71 0 4.811-3.945 8.709-8.815 8.709Z"
            fill={fill}
        />
    </svg>
);

export default UserStar;
